// @flow

import { observer } from "mobx-react";
import React from "react";
import ToggleButton from "react-toggle-button";
import onClickOutside from "react-onclickoutside";

import User from "app/models/User";

import UserStore from "app/stores/UserStore";
import AppearanceStore from "app/stores/AppearanceStore";

import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";
import "./NavbarMenu.scss";

type Props = {
    user: ?User
};

type State = {
    opened: boolean,
    darkTheme: boolean,
    timelineThumbnails: boolean
};

class NavbarMenu extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        let isDarkTheme = false;
        let timelineThumbnails = true;

        const user = this.props.user;
        if (user) {
            isDarkTheme = user.theme === "dark";
            timelineThumbnails = user.timeline_thumbnails;
        }

        this.state = {
            opened: false,
            darkTheme: isDarkTheme,
            timelineThumbnails,
        };
    }

    handleToggle = () => {
        this.setState({ opened: !this.state.opened });
    };

    handleDarkTheme = () => {
        const enabled = !this.state.darkTheme;
        this.setState({ darkTheme: enabled });

        UserStore.updatePreference("theme", enabled ? "dark" : "white");
        this.toggleDOMDarkTheme(enabled);
    };

    handleTimelineThumbnails = () => {
        const enabled = !this.state.timelineThumbnails;
        this.setState({ timelineThumbnails: enabled });

        UserStore.updatePreference("timeline_thumbnails", enabled);
        AppearanceStore.setHiddenThumbnails(!enabled);
    };

    toggleDOMDarkTheme(enabled: boolean) {
        const theme = enabled ? "dark" : "white";
        AppearanceStore.setTheme(theme);
    }

     handleFeedback = () => {
        // Intercom not being displayed
        // window['Intercom']('show');

        if (!window.tidioChatApi) {
            return;
        }
    
        const tidioChat = document.getElementById('tidio-chat');

        if (tidioChat.children.length) {
            window.tidioChatApi.close();
            window.tidioChatApi.hide();
        } else {
            window.tidioChatApi.show();
            window.tidioChatApi.open();
        }
     };

    handleClickOutside = () => {
        this.setState({ opened: false });
    };

    render() {
        const classes = [
            "NavbarMenu",
            this.state.opened ? "NavbarMenu--opened" : ""
        ];

        return (
            <div className={classes.join(" ")}>
                <div className="NavbarMenu__items">
                    <a href="https://www.notion.so/timelinely/Timelinely-Help-Center-0514acee57c84dc8bee25fb6d1c77dfb" target="_blank" rel="noopener noreferrer" className="NavbarMenu__item">
                        Help
                    </a>
                    {/*<a href="/news" className="NavbarMenu__item">
                        What's new
                    </a>*/}
                    {this.renderVolatileMenuLinks()}
                </div>

                <button
                    type="button"
                    className="NavbarMenu__button"
                    onClick={this.handleToggle}
                >
                    <i className="fa fa-bars" /> Menu
                </button>
            </div>
        );
    }

    renderVolatileMenuLinks() {
        const user = this.props.user;
        if (user) {
            return this.renderUserLinks(user);
        }

        return [
            <a key="sign-up" href="/sign-up" className="NavbarMenu__item">
                Sign Up
            </a>,
            <a key="auth" href="/login" className="NavbarMenu__item">
                Login
            </a>
        ];
    }

    renderUserLinks(user: User) {
        const classes = ["dropdown", "NavbarMenu__user"];
        if (this.state.opened) {
            classes.push("open");
        }

        return (
            <div className={classes.join(" ")}>
                <button
                    className="NavbarMenu__user__button dropdown-toggle"
                    type="button"
                    onClick={this.handleToggle}
                >
                    <UserThumbnail
                        name={user.first_name}
                        image={user.profile_image}
                    />
                    {user.firstName}
                    <i className="fa fa-caret-down NavbarMenu__user__icon" />
                </button>

                <ul className="dropdown-menu pull-right">
                    <li>
                        <a href="/dashboard" className="NavbarMenu__item">
                            Dashboard
                        </a>
                    </li>
                    <li>
                        <a
                            href="/dashboard/preferences"
                            className="NavbarMenu__item"
                        >
                            Preferences
                        </a>
                    </li>
                    {this.renderAdminDashboard()}
                    <li>
                        <a href="/auth/logout" className="NavbarMenu__item">
                            Logout
                        </a>
                    </li>
                    {this.renderUserPreferenceToggle(
                        "Dark Theme",
                        this.state.darkTheme,
                        this.handleDarkTheme
                    )}
                    {this.renderUserPreferenceToggle(
                        "Timeline Thumbnails",
                        this.state.timelineThumbnails,
                        this.handleTimelineThumbnails
                    )}
                </ul>
            </div>
        );
    }

    renderAdminDashboard() {
        if (!UserStore.user || !UserStore.user.is_admin) {
            return null;
        }

        return (
            <li>
                <a href="/admin" className="NavbarMenu__item">
                    Admin
                </a>
            </li>
        );
    }

    renderUserPreferenceToggle = (
        label: string,
        value: boolean,
        onToggle: Function
    ) => {
        const classes = ["NavbarMenu__dark-theme-toggle"];
        if (value) {
            classes.push("NavbarMenu__dark-theme-toggle--on");
        }

        return (
            <li className="NavbarMenu__spacer">
                <span className="NavbarMenu__dark-theme-button">{label}</span>
                <span className={classes.join(" ")}>
                    <ToggleButton
                        activeLabel=""
                        inactiveLabel=""
                        value={value}
                        onToggle={onToggle}
                    />
                </span>
            </li>
        );
    };
}

export default observer(onClickOutside(NavbarMenu));



// WEBPACK FOOTER //
// ./src/app/components/NavbarMenu/NavbarMenu.js